import React from "react";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="logo-text">
      <span className="logo-basic-text">k</span>
      <span className="ternary-text logo-x">X</span>
      <span className="logo-basic-text">eep</span>
    </div>
  );
};

export default Logo;
